import React from 'react';
import { Section, Container, Card } from '../common';
import { Star } from 'lucide-react';

const testimonials = [
  {
    name: 'João Silva',
    company: 'Pizza Express',
    text: 'O Léo Delivery transformou minha pizzaria. Agora tenho controle total dos meus pedidos em um só lugar.',
    photo: 'https://i.pravatar.cc/150?u=joao'
  },
  {
    name: 'Maria Oliveira',
    company: 'Burger House',
    text: 'A facilidade de uso do aplicativo é impressionante. Meus funcionários aprenderam rápido e as vendas aumentaram.',
    photo: 'https://i.pravatar.cc/150?u=maria'
  },
  {
    name: 'Roberto Costa',
    company: 'Sushitime',
    text: 'Os relatórios inteligentes me ajudaram a entender onde eu estava perdendo dinheiro. Recomendo muito!',
    photo: 'https://i.pravatar.cc/150?u=roberto'
  }
];

const Testimonials = () => {
  return (
    <Section id="depoimentos" className="bg-light">
      <Container>
        <div className="text-center mb-5">
          <h2 className="fw-bold">Milhares de restaurantes já modernizaram seu atendimento</h2>
          <p className="text-secondary">Restaurantes e deliveries estão usando cardápios digitais para automatizar pedidos, melhorar o atendimento e aumentar o faturamento.</p>
        </div>
        <div className="row g-4">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="col-md-4">
              <Card className="h-100 p-4 border-0 shadow-sm">
                <div className="d-flex mb-3">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} size={16} fill="var(--primary)" color="var(--primary)" />
                  ))}
                </div>
                <p className="font-italic text-secondary mb-4">"{testimonial.text}"</p>
                <div className="d-flex align-items-center">
                  <img 
                    src={testimonial.photo} 
                    alt={testimonial.name} 
                    className="rounded-circle me-3" 
                    style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                  />
                  <div>
                    <h4 className="h6 fw-bold mb-0">{testimonial.name}</h4>
                    <small className="text-muted">{testimonial.company}</small>
                  </div>
                </div>
              </Card>
            </div>
          ))}
        </div>
      </Container>
    </Section>
  );
};

export default Testimonials;
